// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__nAmQ8","productName":"Table_productName__142hG"};